export default __webpack_public_path__ + "static/media/hfp1.0f79c8bf.jpg";